module.exports = __webpack_public_path__ + "media/images/athletes/3442-e44c540e578e75a22ca694ca4661dec7.png";